import React from "react";
import logo from "../../../assets/images/kenal-color-transparent.png";

const Footer = ({ style }) => {
  return (
    <footer
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        fontSize: "0.75rem",
        color: "#9ca3af", // gray-400
        background: "transparent",
        padding: "0.5rem 1rem",
        marginTop: "1rem",
        ...style, // Allow override
      }}
    >
      <span>Secured by</span>
      <img src={logo} alt="logo" style={{ marginLeft: "0.5rem", width: "12px", height: "auto" }} />
      <span style={{ marginLeft: "0.25rem" }}>Kenal e-KYC</span>
    </footer>
  );
};

export default Footer;
